var map = {
	"./assets/clickable/snapchat.svg": "45b73837851ad263e375",
	"./assets/disabled/snapchat.svg": "85a9fbb233627e5a4705",
	"./assets/original/snapchat.svg": "1f952a848212f0f268e4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "46479105ff0e413951b3";